import AppService from 'App/legacy/AppService';
import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

/**
 * Every in-app link to a contact card goes through these two helpers, which is
 * what makes the REACT_CONTACT_CARD cutover a single decision.
 *
 * Only the flag is read here, not `shouldUseAngularPage` — a link never carries
 * a page, so the only question is which card, and the card resolves its own
 * landing page once it is open.
 */
const hasReactCard = () => hasSoftDeployAccess('REACT_CONTACT_CARD');

export const goToContactCard = (contactId: number) => {
	if (hasReactCard()) {
		Tools.$state.go('react-root-contactCard', { id: contactId });
		return;
	}
	Tools.$state.go('contact.dashboard', { id: contactId });
};

export const getContactCardHref = (contactId: number) => {
	if (hasReactCard()) {
		// The react-root state has no customerId in its url — react-router runs on
		// the hash below it, so the card's route is just /contacts/:id/:page?.
		return Tools.$state.href('react-root-contactCard', { id: contactId });
	}
	return Tools.$state.href('contact.dashboard', {
		customerId: AppService.getCustomerId(),
		id: contactId
	});
};
